import { Injectable } from "@angular/core";
import { ContractsService } from "../contracts.service";
import { Web3Service } from "app/services/web3/web3.service";
import { Observable, first, from } from "rxjs";
import { eContracts } from "../contract.config";

@Injectable({
    providedIn: 'root'
})
export class NFTService {

    public contract: any

    constructor(
        private contractsService: ContractsService,
        private web3Service: Web3Service
    ) {
        // this.contractsService.setContract(this.web3Service.getWeb3(), eContracts.KMONFT);
        // this.contractsService.getContractIstances(eContracts.KMONFT).pipe(first()).subscribe(c => this.contract = c);
        this.contract = this.contractsService.getContract( eContracts.KMONFT);
    }

    //Maybe is a boolean
    isApprovalForAll(ownerAddress: string, operatorAddress: string): Observable<any> {
        return from(this.contract.methods.isApprovedForAll(ownerAddress, operatorAddress).call());
    }

    ownedKryptomons(ownerAddress: string): Observable<any> {
        return from(this.contract.methods.ownedKryptomons().call({ from: ownerAddress }));
    }

    //check if its a promise
    timeToHatch(): Observable<any> {
        return from(this.contract.methods.timeToHatch().call());
    }

    setApprovalForAll(ownerAddress: string, operatorAddress: string, approved: boolean): Observable<any> {
        return from(this.contract.methods.setApprovalForAll(operatorAddress, approved).send({ from: ownerAddress }));
    }

}

@Injectable({
    providedIn: 'root'
})
export class NFTv2Service {

    public contract: any

    constructor(
        private contractsService: ContractsService,
        private web3Service: Web3Service
    ) {
        // this.contractsService.setContract(this.web3Service.getWeb3(), eContracts.KMONFTV2);
        // this.contractsService.getContractIstances(eContracts.KMONFTV2).pipe(first()).subscribe(c => this.contract = c);
        this.contract = this.contractsService.getContract( eContracts.KMONFTV2);

    }

    //Maybe is a boolean
    isApprovalForAll(ownerAddress: string, operatorAddress: string): Observable<any> {
        return from(this.contract.methods.isApprovedForAll(ownerAddress, operatorAddress).call());
    }

    setApprovalForAll(ownerAddress: string, operatorAddress: string, approved: boolean): Observable<any> {
        return from(this.contract.methods.setApprovalForAll(operatorAddress, approved).send({ from: ownerAddress }));
    }

    safeBatchTransferFrom(fromAddress: string, receiverAddress: string, ids: string[], values: number[], data: any): Observable<any> {
        return from(this.contract.methods.safeBatchTransferFrom(fromAddress, receiverAddress, ids, values, data)
            .send({ from: fromAddress }));
    }

    ownedKryptomons(ownerAddress: string): Observable<any> {
        return from(this.contract.methods.ownedKryptomons().call({ from: ownerAddress }));
    }

    migrateBatch(ownerAddress: string, tokenIds: string[], genes: string[], deadlines: string[],
        vs: number[], rs: any[], ss: any[]): Observable<any> {
        return from(this.contract.methods.migrateBatch(tokenIds, genes, deadlines, vs, rs, ss).send({ from: ownerAddress }))
    }

    spinTheWheel(ownerAddress: string): Observable<any> {
        return from(this.contract.methods.spinTheWheel().send({ from: ownerAddress }));
    }
}